// removed by extract-text-webpack-plugin
module.exports = {"fullScreen":"_2_7c","standard":"_3Cjh","fullScreenOverlay":"_1eYo","button":"_3QT8","closeWhite":"_1lrH"};


//////////////////
// WEBPACK FOOTER
// ./~/@pickle/pickle-shared/src/features/Modal/Modal/Modal.scss
// module id = iPhl
// module chunks = 0